import { Component, Input } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { IonicModule, ModalController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { BrukerService } from '../../../services/bruker/bruker.service';
import { LoadingController } from '@ionic/angular';
import { SelvbetjeningService } from 'src/app/services/selvbetjening/selvbetjening.service';
import {
  Account,
  UCAddress,
  UCMe
} from 'src/app/services/selvbetjening/selvbetjening.types';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-editcontact',
  templateUrl: 'editcontact.component.html',
  styleUrls: ['./editcontact.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule]
})
export class editcontactComponent {
  @Input() canChangeAddress: boolean;
  editcontactGroup: FormGroup;
  ucMe: UCMe;
  brukerSubscription: Subscription;
  defaultAccount: Account;
  address: UCAddress;

  constructor(
    private _brukerService: BrukerService,
    private _toast: ToastController,
    private modalCtrl: ModalController,
    public loadingController: LoadingController,
    private selvbetjeningService: SelvbetjeningService
  ) {}

  ngOnInit() {
    this.selvbetjeningService.getContact().subscribe({
      next: (res) => {
        this.ucMe = res;
        this.defaultAccount =
          res.accounts.find((x) => x.Guid === res.customer.DefaultAccount) ||
          res.accounts[0];
        this.address = this.defaultAccount.Addresses.find(
          (x) => x.Type === 'postaladr'
        );
        this.initForm();
      }
    });
  }

  ngOnDestroy() {
    this.brukerSubscription?.unsubscribe();
  }

  initForm() {
    const communication = this.defaultAccount.Communication;
    const email = communication.find((x) => x.Channel === 'Email');
    const mobile = communication.find((x) => x.Channel === 'Mobile');
    const address = this.address;

    this.editcontactGroup = new FormGroup({
      epost: new FormControl(
        email.Value ?? '',
        Validators.compose([Validators.email, Validators.required])
      ),
      mobilnummer: new FormControl(
        mobile.Value ?? '',
        Validators.compose([
          Validators.minLength(8),
          Validators.required,
          Validators.pattern('^[0-9 +-_]{8,}$')
        ])
      ),
      gatenavn: new FormControl(address.StreetName ?? ''),
      husnr: new FormControl(address.BuildingNumber ?? ''),
      postnummer: new FormControl(
        address.PostCode ?? '',
        Validators.pattern('^[0-9]{4}$')
      ),
      adrpoststed: new FormControl(address.CityName ?? ''),
      careOf: new FormControl(address.CareOf ?? '')
    });
  }

  async putContact() {
    const loading = await this.loadingController.create({
      message: 'Vennligst vent...',
      mode: 'ios'
    });
    await loading.present();

    const contact = {};
    if (this.editcontactGroup.get('epost')?.value) {
      contact['email'] = this.editcontactGroup.get('epost').value;
    }
    if (this.editcontactGroup.get('mobilnummer')?.value) {
      contact['mobile'] = this.editcontactGroup.get('mobilnummer').value;
    }
    if (this.canChangeAddress && this.editcontactGroup.get('gatenavn')?.value) {
      const address = this.defaultAccount.Addresses.find(
        (x) => x.Type === 'postaladr'
      );
      contact['address'] = {
        c_o: this.editcontactGroup.get('careOf')?.value ?? '',
        street: this.editcontactGroup.get('gatenavn')?.value ?? '',
        house_no: this.editcontactGroup.get('husnr')?.value ?? '',
        postal_no: this.editcontactGroup.get('postnummer')?.value ?? '',
        floor: address.FloorIdentification ?? ''
      };
    }
    const payload = JSON.stringify(contact);
    this.selvbetjeningService.updateContact(payload).subscribe({
      next: () => {
        this._toast
          .create({
            message: 'Oppdatert!',
            duration: 4000,
            position: 'middle',
            color: 'success'
          })
          .then((toast) => {
            loading.dismiss();
            toast.present();
          });

        this.modalCtrl.dismiss({
          oppdatertKunde: true
        });
      },
      error: (err) => {
        this._toast
          .create({
            message:
              'Kontaktinformasjon ble dessverre ikke oppdatert, prøv igjen litt senere. Dersom feil vedvarer, kontakt kundeservice.',
            duration: 4000,
            position: 'middle',
            color: 'danger'
          })
          .then((toast) => {
            loading.dismiss();
            toast.present();
          });
      }
    });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  async checkPostnr() {
    const strPostNr: string = this.editcontactGroup.get('postnummer').value;
    if (strPostNr.length == 4) {
      this.brukerSubscription = this._brukerService
        .getPoststed(strPostNr)
        .subscribe((response) => {
          this.editcontactGroup.patchValue({
            adrpoststed: response
          });
        });
    }
  }
}
